import React, { useEffect, useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap';
import { IoIosArrowDown } from 'react-icons/io';
import { ErrorMessage, Field, } from 'formik';
import { CommonAxiosGet } from '../../../CommonUtilities/CommonAxios/CommonAxios';
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';
import { handleKeyPressNumeric, handleNumericDot } from '../../../CommonUtilities/Validations/RegularExpAndVar';
import { calculatePercentage } from '../../../CommonUtilities/CommonFunctions/CommonFunction';
export default function Inter(props) {
  
  const { years,Formik } = props;

  useEffect(() => {
    const percent = calculatePercentage(
      Formik.values.interMarksSecured,
      Formik.values.interTotalMarks
    );
    Formik.setFieldValue("interPercentage", percent);
  }, [Formik.values.interMarksSecured, Formik.values.interTotalMarks]);

  const [subjectData, setSubjectData] = useState()
  const getpostDataFunction = () => {
    let villUrl = config.url.CONTEXT_READ_URL + "inter-subjects";
    CommonAxiosGet(villUrl).then((response) => {
      if (response?.data?.status === true) {
        setSubjectData(response?.data?.intersubjects)
      }
      else {
        setSubjectData([])
      }
    });
  };
  useEffect(() => { getpostDataFunction(); }, [])
  return (
    <React.Fragment>
      <div className="personal-head">
        <span> Intermediate or its Equivalent Qualification:</span>
      </div>
      <div className="personal-row mb-3">
        <Row className="row mb-2">
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
            <div className="input-div position-relative">
              <Form.Group controlId="interCourse" >
                <Form.Label className="input-lable mb-2">Course <font color="red">*</font></Form.Label>
                <Field as="select"
                  className="input-field form-control"
                  name="interCourse" >
                  <option value="">Select</option>
                  <option>Intermediate</option>
                  <option>Intermediate Equivalent</option>
                </Field>
                <ErrorMessage
                  name="interCourse"
                  component="div"
                  className="text-error"
                />
              </Form.Group>

            </div>
          </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
            <div className="input-div position-relative">
              <Form.Group controlId="board_inter" >
                <Form.Label className="input-lable mb-2">Select Board <font color="red">*</font></Form.Label>
                <Field as="select" className="input-field form-control" name="interBoard">
                  <option value="">Select</option>
                  <option value="U2">CBSE</option>
                  <option value="U3">ICSE</option>
                  <option value="U4">OTHER STATE BOARD</option>
                  <option value="U5">Andhra Pradesh State Board of Intermediate Education</option>
                  <option value="U205">APOSS</option>
                </Field>
                <ErrorMessage
                  name="interBoard"
                  component="div"
                  className="text-error"
                />
              </Form.Group>
              <IoIosArrowDown className="dropdown-icon" />
            </div>
          </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
            <div className="input-div position-relative">
              <Form.Group controlId="interMedium" >
                <Form.Label className="input-lable mb-2">Select Medium<font color="red">*</font> </Form.Label>
                <Field as="select" className="input-field form-control" name="interMedium">
                  <option value="">Select</option>
                  <option value="1">TELUGU</option>
                  <option value="2">URDU</option>
                  <option value="3">HINDI</option>
                  <option value="4">KANNADA</option>
                  <option value="5">ORIYA</option>
                  <option value="6">TAMIL</option>
                  <option value="7">ENGLISH</option>
                  <option value="8">SANSKRIT</option>
                </Field>
                <ErrorMessage
                  name="interMedium"
                  component="div"
                  className="text-error"
                />
              </Form.Group>
              <IoIosArrowDown className="dropdown-icon" />
            </div>
          </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
            <div className="input-div position-relative">
              <Form.Group controlId="interSecondLanguage" >
                <Form.Label className="input-lable mb-2">2nd Language<font color="red">*</font></Form.Label>
                <Field as="select"
                  className="input-field form-control"
                  name="interSecondLanguage">
                  <option value="">Select</option>
                  <option value="1">TELUGU</option>
                  <option value="2">URDU</option>
                  <option value="3">HINDI</option>
                  <option value="4">KANNADA</option>
                  <option value="5">ORIYA</option>
                  <option value="6">TAMIL</option>
                  <option value="7">ENGLISH</option>
                  <option value="8">SANSKRIT</option>
                  <option value="10">ARABIC</option>
                </Field>
                <ErrorMessage
                  name="interSecondLanguage"
                  component="div"
                  className="text-error"
                />
              </Form.Group>
              <IoIosArrowDown className="dropdown-icon" />
            </div>
          </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
            <div className="input-div position-relative">
              <Form.Group controlId="interYearOfPass" >
                <Form.Label className="input-lable mb-2">Year of Passing<font color="red">*</font> </Form.Label>
                <Field as="select"
                  className="input-field form-control"
                  name="interYearOfPass">
                  <option value="">Select</option>
                  {years.filter(year => year !== 2025 && year !== 2026)?.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </Field><ErrorMessage
                  name="interYearOfPass"
                  component="div"
                  className="text-error"
                />
              </Form.Group>
              <IoIosArrowDown className="dropdown-icon" />
            </div>
          </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
            <Form.Group controlId="interHallTicket" >
              <Form.Label className="input-lable mb-2">Hall Ticket No <font color="red">*</font></Form.Label>
              <Field
                type="text"
                name="interHallTicket"
                className="input-field form-control"
                placeholder="Enter Hall Ticket Number"
                maxLength={15}
              />
              <ErrorMessage
                name="interHallTicket"
                component="div"
                className="text-error"
              />
            </Form.Group>
          </Col>
           <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                      <Form.Group controlId="interTotalMarks" >
                        <Form.Label className="input-lable mb-2">Total marks<font color="red">*</font></Form.Label>
                        <Field
                          type="text"
                          name="interTotalMarks"
                          className="input-field form-control"
                          maxLength={4}
                          onChange={(e) => {
                            handleNumericDot(e);
                          }}
                        />
                        <ErrorMessage
                          name="interTotalMarks"
                          component="div"
                          className="text-error"
                        />
                      </Form.Group>
                    </Col>
                     <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
                      <Form.Group controlId="interMarksSecured" >
                        <Form.Label className="input-lable mb-2">Marks Secured<font color="red">*</font></Form.Label>
                        <Field
                          type="text"
                          name="interMarksSecured"
                          className="input-field form-control"
                          maxLength={4}
                          onChange={(e) => {
                            handleNumericDot(e);
                          }}
                        />
                        <ErrorMessage
                          name="interMarksSecured"
                          component="div"
                          className="text-error"
                        />
                      </Form.Group>
                    </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
            <Form.Group controlId="interPercentage" >
              <Form.Label className="input-lable mb-2">Percentage of marks(including languages) <font color="red">*</font></Form.Label>
              <Field
                type="text"
                name="interPercentage"
                className="input-field form-control"
                maxLength={4}
                 onChange={(e) => {
                  handleNumericDot(e);
                 }}/>
              <ErrorMessage
                name="interPercentage"
                component="div"
                className="text-error"
              />
            </Form.Group>
          </Col>
           <Col xxl={3} xl={3} lg={4}
                                    md={6}
                                    sm={12}
                                    xs={12}
                                    className="mb-2 mt-2"
                                  >
                                    <Form.Group controlId="">
                                      <Form.Label className="input-lable mb-2">
                                        Have you studied English as one of your Subjects ?<font color="red">*</font>
                                      </Form.Label>
                                      <div className="form-border">
                                        <Field
                                          type="radio"
                                          name="isEnglishInter"
                                          value="Yes"
                                          className="form-sub me-1"/>
                                        Yes &nbsp;&nbsp;&nbsp;&nbsp;
                                        <Field
                                          type="radio"
                                          value="No"
                                          name="isEnglishInter"
                                          className="form-sub me-1" />
                                        No &nbsp;&nbsp;&nbsp;&nbsp;
                                      </div>
                                      <ErrorMessage
                                        name="isEnglishInter"
                                        component="div"
                                        className="text-error"
                                      />
                                    </Form.Group>
                                  </Col>
        </Row>
        <Row className="row mb-2">
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
            <div className="input-div position-relative">
              <Form.Group controlId="interSubject1" >
                <Form.Label className="input-lable mb-2">Subject 1 <font color="red">*</font></Form.Label>
                <Field as="select"
                  className="input-field form-control"
                  name="interSubject1">
                  <option value="">Select</option>
                  {
                    subjectData?.map((item, i) => {
                      return (
                        <option value={item.subject_code} key={i}>{item?.subject_name}</option>
                      )
                    })
                  }
                </Field>
                <ErrorMessage
                  name="interSubject1"
                  component="div"
                  className="text-error"
                />
              </Form.Group>
              <IoIosArrowDown className="dropdown-icon" />
            </div>
          </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
            <div className="input-div position-relative">
              <Form.Group controlId="interSubject2" >
                <Form.Label className="input-lable mb-2">Subject 2 <font color="red">*</font></Form.Label>
                <Field as="select"
                  className="input-field form-control"
                  name="interSubject2">
                  <option value="">Select</option>
                  {
                    subjectData?.map((item, i) => {
                      return (
                        <option value={item.subject_code} key={i}>{item?.subject_name}</option>
                      )
                    })
                  }
                </Field>
                <ErrorMessage
                  name="interSubject2"
                  component="div"
                  className="text-error"
                />
              </Form.Group>
              <IoIosArrowDown className="dropdown-icon" />
            </div>
          </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
            <div className="input-div position-relative">
              <Form.Group controlId="interSubject3" >
                <Form.Label className="input-lable mb-2">Subject 3 <font color="red">*</font></Form.Label>
                <Field as="select"
                  className="input-field form-control"
                  name="interSubject3">
                  <option value="">Select</option>
                  {
                    subjectData?.map((item, i) => {
                      return (
                        <option value={item?.subject_code} key={i}>{item?.subject_name}</option>
                      )
                    })
                  }
                </Field>
                <ErrorMessage
                  name="interSubject3"
                  component="div"
                  className="text-error"
                />
              </Form.Group>
              <IoIosArrowDown className="dropdown-icon" />
            </div>
          </Col>
          <Col xxl={3} xl={3} lg={4} md={6} sm={12} xs={12} className='mb-3'>
            <div className="input-div position-relative">
              <Form.Group controlId="interSubject4" >
                <Form.Label className="input-lable mb-2">Subject 4</Form.Label>
                <Field as="select"
                  className="input-field form-control"
                  name="interSubject4">
                  <option value="">Select</option>
                  {
                    subjectData?.map((item, i) => {
                      return (
                        <option value={item.subject_code} key={i}>{item?.subject_name}</option>
                      )
                    })
                  }
                </Field>
                <ErrorMessage
                  name="interSubject4"
                  component="div"
                  className="text-error"
                />
              </Form.Group>
              <IoIosArrowDown className="dropdown-icon" />
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}
